import { Link } from 'react-router-dom';
import logo from '../../assets/ueg-logo.png';
import { OnboardingBlock, FormCol } from './OnboardingTemplate.styles';

function OnboardingTemplate({ children }) {
  return (
    <OnboardingBlock>
      <FormCol>
        <div className="form-content">
          <Link className="brand_logo" to="/">
            <img src={logo} width="148" alt="logo" />
          </Link>
          {children}
        </div>
      </FormCol>
    </OnboardingBlock>
  );
}

export default OnboardingTemplate;
